import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { COMPANY, SITE_URL, SUPPORT_EMAIL, USES_NON_ESSENTIAL_COOKIES } from '../data/launch';
export function CookiePolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#FAFAFA] font-sans selection:bg-kitty-yellow-200 selection:text-kitty-dark" data-id="element-417" data-mp="3cqi0g7evmmv6">
      <SEO title="Cookie Policy | KittyPot" description="Which cookies and similar technologies kittypot.com uses, why they are used, and how to manage them." ogTitle="KittyPot Cookie Policy" ogDescription="Which cookies and similar technologies kittypot.com uses." path="/cookie-policy" data-id="element-418" data-mp="37sov1gledwvy" />
      <Navbar data-id="element-419" data-mp="3vhr9kfkqj9m8" />
      <main className="pt-32 pb-24" data-id="element-420" data-mp="3vf54qnp8b87p">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-421" data-mp="3rgp9jwizutj7">
          <h1 className="text-4xl font-black text-kitty-dark mb-4" data-id="element-422" data-mp="3re33607uak2k">
            Cookie Policy
          </h1>
          <p className="text-gray-500 font-medium mb-10" data-id="element-423" data-mp="21x985iqqjw4q">
            Last updated: 26 August 2026
          </p>

          <div className="prose prose-gray max-w-none text-gray-600 space-y-6" data-id="element-424" data-mp="26vsuhk98r9xm">
            <p data-id="element-425" data-mp="2bvf8hvww8u7h">
              This policy explains the cookies and similar technologies used on{' '}
              {SITE_URL}, operated by {COMPANY.legalName}. It covers this
              website only. How the KittyPot app handles your data is explained
              in our{' '}
              <Link to="/privacy-policy" className="font-semibold text-kitty-dark underline underline-offset-2 hover:text-kitty-yellow-700" data-id="element-426" data-mp="2ku0kf87v1aza">
                Privacy Policy
              </Link>
              .
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-427" data-mp="2zmkm04fd3aem">
              1. What cookies and local storage are
            </h2>
            <p data-id="element-428" data-mp="2evykq6tx86ss">
              A cookie is a small text file a website can place on your device.
              Local storage works in a similar way, letting a site remember
              small pieces of information in your browser. Both are used to make
              a website work properly and, in some cases, to understand how it
              is used.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-429" data-mp="2jtqjnkszgt6h">
              2. Strictly necessary technologies
            </h2>
            <p data-id="element-430" data-mp="2snv85xkn9siu">
              We use a small amount of strictly necessary browser storage to run
              this website, for example to remember a choice you have made
              about this notice. These are required for the site to function,
              they do not track you across other websites, and they cannot be
              switched off through a consent banner. Where a preference is
              stored, it stays in your browser until you clear it.
            </p>
            <p data-id="element-431" data-mp="3juve96fuvn0j">
              This website does not load fonts or tracking scripts from third
              parties. Images are served from a content delivery network, which
              receives your IP address as a normal part of sending the image to
              your browser, and if you join our waitlist your details are
              submitted through Google infrastructure as described in our
              Privacy Policy. Neither sets a tracking cookie on this site.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-432" data-mp="355za3kgx6u57">
              3. Analytics technologies
            </h2>
            {USES_NON_ESSENTIAL_COOKIES ? <p data-id="element-433" data-mp="2r8aq0euofr17">
                We use analytics to understand how this website is used in
                aggregate, such as which pages are visited. These are
                non-essential, so they are only used if you accept them in our
                cookie notice, and you can change your mind at any time.
              </p> : <p data-id="element-434" data-mp="2qhaw9agm8bij">
                We do not currently run analytics cookies on this website. If we
                introduce them, we will update this policy and ask for your
                consent before they are used.
              </p>}

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-435" data-mp="2hih35u2hu39q">
              4. Marketing technologies
            </h2>
            <p data-id="element-436" data-mp="27iq8nsdxno9n">
              We do not use advertising or cross-site tracking cookies on this
              website. We do not sell your browsing data, and we do not run
              targeted advertising from this site.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-437" data-mp="1xswxgshpdb5x">
              5. Managing your preferences
            </h2>
            <p data-id="element-438" data-mp="1toyychsdo0cv">
              {USES_NON_ESSENTIAL_COOKIES ? 'You can accept or reject non-essential technologies using the notice shown when you first visit. You can also block or delete cookies and clear local storage in your browser settings.' : 'Because we only use strictly necessary storage, there is nothing to consent to at the moment. You can still block or delete cookies and clear local storage in your browser settings at any time.'}{' '}
              Blocking storage may stop parts of the website working as
              intended.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-439" data-mp="d80936wshhp6">
              6. Changes to this policy
            </h2>
            <p data-id="element-440" data-mp="3ho1eb1ace8x6">
              If we add new technologies to this website we will update this
              policy and the date at the top of the page.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-441" data-mp="3lobge2v0kf6r">
              7. Contact us
            </h2>
            <p data-id="element-442" data-mp="2tz8bckvaz0t2">
              If you have any questions about this Cookie Policy, email{' '}
              <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-kitty-dark underline underline-offset-2 hover:text-kitty-yellow-700" data-id="element-443" data-mp="2y0bsrbt014we">
                {SUPPORT_EMAIL}
              </a>{' '}
              or write to us:
            </p>
            <address className="not-italic" data-id="element-444" data-mp="evwpwx9aq2d1">
              {COMPANY.addressLines.map(line => <React.Fragment key={line} data-id="element-445" data-mp="9wtpxr86ambx">
                  {line}
                  <br data-id="element-446" data-mp="9ywmku3tzdpm" />
                </React.Fragment>)}
            </address>
          </div>
        </div>
      </main>
      <Footer data-id="element-447" data-mp="3ddsby6v6ckt1" />
    </div>;
}